<template>
  <div>
    <Modal
      v-if="modalShow"
      @hideModal="modalShow = false"
      hide-footer
      size="extra-extra-large"
      id="common-iframe-modal"
    >
      <iframe :src="iframeUrl" height="800px" width="100%" frameborder="0"></iframe>
    </Modal>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useScheduleServiceStore } from "../../store/ScheduleServiceStore/ScheduleServiceStore";
import Modal from "../Shared/Modal/Modal.vue";

// Define props
const { ctaActiveComponentProps, pricedetails } = defineProps({
  ctaActiveComponentProps: {
    type: String,
    default: "",
  },
  pricedetails: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["hidemodal"]);

const modalShow = ref(true);

const scheduleServiceStore = useScheduleServiceStore();

const scheduleServiceXTimeIframePopUpDetails = computed(() => {
  return scheduleServiceStore.scheduleServiceXTimeIframePopUpDetails;
});

const iframeUrl = computed(() => {
  let url = ctaActiveComponentProps?.url || pricedetails?.iframeUrl || "";
  if (scheduleServiceXTimeIframePopUpDetails.value?.url) {
    url = scheduleServiceXTimeIframePopUpDetails.value.url || url;
  }
  return url;
});

// Watch for modal close
watch(modalShow, (newVal) => {
  if (!newVal) {
    scheduleServiceStore.setScheduleServiceXTimeIframePopUpDetails(null);
    emit("hidemodal", newVal);
  }
});

</script>
